/* global $ */

import Swiper, { Pagination, Navigation } from 'swiper';

class PageOther {
  constructor() {
    this.id = this.getRandomId();
    this.$window = $(window);

    // this.$statement_primary = $('.Statement--primary');
    // this.$statement_secondary = $('.Statement--secondary');
    this.swipers = [];

    if ($('.RTE').find('.swiper').length) {
      $('.RTE')
        .find('.swiper')
        .each((i, e) => {
          this.swipers.push(
            new Swiper('#' + $(e).attr('id'), {
              modules: [Navigation, Pagination],
              loop: false,
              navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                bulletElement: 'button',
              },
            }),
          );
        });
    }

    this.$window
      .on('resize.' + this.id, () => {
        this.onWindowResize();
      })
      .on('scroll.' + this.id, () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }
  onWindowResize() {
    // this.windowHeight = window.innerHeight;
    // this.onWindowScroll();
  }
  onWindowScroll() {}
  getRandomId() {
    let c = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let cl = c.length;
    let r = '';
    for (var i = 0; i < 8; i++) {
      r += c[Math.floor(Math.random() * cl)];
    }
    return r;
  }
  destroy() {
    if (this.swipers.length > 0) {
      for (let i = 0; i < this.swipers.length; i++) {
        this.swipers[i].destroy();
      }
      this.swipers = [];
    }
  }
}

export default PageOther;
